module.exports = __webpack_public_path__ + "static/teamPicture-26797eebc6e151fd93f1e12169ff9d32.png";